<template>
  <div class="LyricsImport">
    <SmallButton border-color="primary"  class="add-button" @click="openExplorer">
      Importuj
    </SmallButton>
    <input
      id="multiple-import"
      accept="image/jpeg,image/png,application/pdf"
      autocomplete="off"
      type="file"
      @change="handleOnChange"
      multiple="multiple"
      ref="multipleImport" />
  </div>
</template>

<script>
import SmallButton from '../components/input/SmallButton.vue'
import { getAndroidContext } from '@/services/sessionProps'

export default {
  name: 'LyricsImport',
  data () {
    return {
      id: null,
      isAndroidContext: false,
    }
  },
  components: {
    SmallButton,
  },
  mounted () {
    this.isAndroidContext = getAndroidContext().isAndroidContext()
  },
  methods: {
    openExplorer() {
      this.$refs.multipleImport.click()
    },

    async handleOnChange(e) {
      const files = e.target.files
      const correctFileTypes = Array.from(files).every(key => {
        return key.type === "image/jpeg"
        || key.type === "image/png"
        || key.type === "application/pdf" })

      if(correctFileTypes) {
        this.$router.push({ name: 'lyrics-import', params: { files: e.target.files } })
      } else {
        this.$root.showSnackbar("Dozwolone są tylko formaty jpg/jpeg, png oraz pdf!", "error")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.LyricsImport {
  position: relative;

  input[type=file] {
    display: none;
  }

  .content {
    box-sizing: border-box;
    margin: 90px auto auto;
    padding: 0 40px;
    min-height: calc(100vh - 358px);
    padding-bottom: 20px;

    @media screen and (max-width: $phone-max-width) {
      padding: 0;
    }

    .header {
      h1 {
        color: #d6ae5d;
        border-bottom: 2px solid #fefefe;
        text-align: center;
        padding-bottom: 20px;
        margin-top: 0;
        margin-bottom: 30px;
        padding: 15px;

        @media screen and (max-width: $phone-max-width) {
          padding-top: 15px;
          margin-bottom: 20px;
        }
      }
    }
  }

  .input-field {
    text-align: center;

    input {
      display: none;
    }

    label {
      display: inline-block;
      min-width: 96px;
      padding: 5px;
      border: none;
      background-color: transparent;
      font-weight: 400;
      color: white;
      cursor: pointer;
      outline: none;
    }
  }
}
</style>
